<div class="row">
  <div class="col-12 col-md-12">
    <section class="container-style">
      <div class="row">
        <form [formGroup]="formInvoiceCashReceiptRetention">
          <div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
                <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                  [width]="'5.5rem'" [severity]="'success'" (onClick)="newRetention()"></app-custom-button>
              </div>
            </div>
            <div class="row">
              <div class="col tax">
                <app-custom-inputgroup [inputValue]="codeNameTax" [labelText]="'Impuesto'"
                  [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Impuesto'" [required]="true"
                  [recovery]="true" (onClick)="openTaxSelectionModal()"></app-custom-inputgroup>
                <app-custom-modal #taxSelection [label]="'Seleccionar'" [header]="'Selección de Impuestos'"
                  [children]="componentTableSelection" [inputs$]="inputsForTaxesSelection$" [output$]="output$"
                  (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
              </div>
              <div class="col type-rate">
                <app-custom-input-text [labelText]="'Tipo'" [value]="taxType" [disabled]="true"></app-custom-input-text>
              </div>
              <div class="col values">
                <app-custom-input-decimal [value]="minimumBase" [labelText]="'Base Mínima'"
                  [disabled]="true"></app-custom-input-decimal>
              </div>
              <div class="col values">
                <app-custom-input-decimal formControlName="base" [labelText]="'Base'"
                  (onChangeNumber)="getTaxTotalValue()"></app-custom-input-decimal>
              </div>
              <div class="col type-rate">
                <app-custom-input-decimal formControlName="rate" [labelText]="'Tarifa'"></app-custom-input-decimal>
              </div>
              <div class="col values">
                <app-custom-input-decimal [value]="taxTotalValue" [labelText]="'Total'"
                  [disabled]="true"></app-custom-input-decimal>
              </div>
              <div class="col save-button d-flex align-items-end mt-2 justify-content-end">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm"
                  [variant]="undefined" (onClick)="send()"></app-custom-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
    <section class="container-style mt-2">
      <div id="header-detail" class="d-flex flex-row justify-content-between"></div>
      <div class="pt-1">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
          <app-custom-table [headers]="headers" [data]="taxData" [actions]="tableActions"
            (onPageChange)="onPageChange($event)" (onRecoverData)="getAllRetentionsModalWithPagination()"
            (onAction)="onAction($event)"></app-custom-table>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
          <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
            (onClick)="close()"></app-custom-button>
        </div>
      </div>
    </section>
  </div>
</div>